import { createContext, Dispatch, ReactNode, SetStateAction, useState } from "react";
import Loading from "./Loading";


type LoadingContextProviderProps = {
    children: ReactNode;
}

type LoadingContextT = {
    loading: boolean,
    setLoading: Dispatch<SetStateAction<boolean>>,
}

export const LoadingContext = createContext<LoadingContextT | null>(null);

const LoadingContextProvider = ({ children }: LoadingContextProviderProps) => {
    const [loading, setLoading] = useState(false);

    return (
        <LoadingContext.Provider
            value={{
                loading,
                setLoading
            }}>
            {children}
            <Loading />
        </LoadingContext.Provider>
    )
}

export default LoadingContextProvider;
